module.exports = __webpack_public_path__ + "img/img5.f184fe0e.png";